export const translations = {
  fi: {
    nav: {
      home: 'Koti',
      lunch: 'Lounas',
      about: 'Meistä',
      contact: 'Yhteystiedot'
    },
    hero: {
      badge: 'Ravintola La Maria · Vantaa',
      title: 'Herkullinen lounasbuffet',
      subtitle: 'Tuoreista raaka-aineista päivittäin valmistettu monipuolinen lounasbuffet lämpimässä ilmapiirissä.',
      ctaLunch: 'Katso lounas',
      ctaContact: 'Ota yhteyttä'
    },
    info: {
      hoursTitle: 'Aukioloajat',
      weekdays: 'Ma–Pe',
      weekend: 'La–Su',
      closed: 'Suljettu',
      locationTitle: 'Sijainti',
      phoneTitle: 'Soita meille'
    },
    lunch: {
      heading: 'Viikon Lounas',
      subheading: 'Päivittäin vaihtuva, tuoreista raaka-aineista valmistettu lounasbuffet.',
      days: {
        monday: 'Maanantai',
        tuesday: 'Tiistai',
        wednesday: 'Keskiviikko',
        thursday: 'Torstai',
        friday: 'Perjantai'
      },
      week: 'Viikko',
      servedDaily: 'Tarjolla Ma–Pe klo 10–16',
      downloadPdf: 'Lataa viikon menu (PDF)',
      noMenu: 'Päivän menu päivitetään pian.'
    },
    about: {
      heading: 'Meistä',
      p1: 'Yli 15 vuoden kokemuksella ravintola-alalta Ravintola La Maria on luotettava valinta laadukkaaseen lounasbuffetiin. Ammattitaito, tasainen laatu ja erinomainen palvelu ovat toimintamme perusta.',
      p2: 'Valmistamme päivittäin monipuolisen ja tasapainoisen buffetin tuoreista ja laadukkaista raaka-aineista, jotta voimme tarjota asiakkaillemme aina herkullisen ja varman lounaskokemuksen. Olitpa sitten nopealla lounaalla tai rauhallisella ruokatauolla, tehokas palvelumme ja viihtyisä ilmapiirimme takaavat miellyttävän hetken.',
      p3: 'Ravintola La Mariassa kokemus ei ole pelkkä numero – se näkyy jokaisessa annoksessa, jonka tarjoamme.',
      catering: 'Tilamme vetävät jopa 200 henkilöä, ja tarjoamme myös pitopalvelua sekä cateringia juhliin ja tapahtumiin.',
      stat1: 'Vuoden kokemus',
      stat2: 'Tuoreet raaka-aineet',
      stat3: 'Hengen tilat'
    },
    contact: {
      heading: 'Yhteystiedot',
      subheading: 'Tervetuloa Ravintola La Mariaan!',
      address: 'Osoite',
      phone: 'Puhelin',
      email: 'Sähköposti',
      hours: 'Aukioloajat',
      directions: 'Katso reitti'
    },
    footer: {
      tagline: 'Monipuolinen lounasbuffet Vantaalla',
      rights: 'Kaikki oikeudet pidätetään.'
    },
    admin: {
      title: 'Hallintapaneeli',
      login: 'Kirjaudu sisään',
      password: 'Salasana',
      logout: 'Kirjaudu ulos',
      wrongPassword: 'Väärä salasana',
      manageLunch: 'Hallitse lounaslistaa',
      dishName: 'Annoksen nimi (suomi)',
      dishDesc: 'Kuvaus (suomi)',
      dishNameEn: 'Dish name (English)',
      dishDescEn: 'Description (English)',
      translate: 'Käännä englanniksi',
      translating: 'Käännetään...',
      save: 'Tallenna',
      saving: 'Tallennetaan...',
      saved: 'Tallennettu!',
      add: 'Lisää annos',
      remove: 'Poista',
      day: 'Päivä',
      scheduleTitle: 'Ajasta päivitys',
      scheduleHint: 'Aseta aika, jonka kuluttua muutokset tulevat näkyviin verkkosivuille. Jätä nollaan päivittääksesi heti.',
      hours: 'Tuntia',
      minutes: 'Minuuttia',
      saveInstant: 'Tallenna heti',
      scheduleBtn: 'Ajasta ja käynnistä ajastin',
      scheduled: 'Ajastettu!',
      pendingNotice: 'Päivitys odottaa aktivointia',
      activatesIn: 'Aktivoituu',
      cancelSchedule: 'Peruuta ajastus',
      translateAll: 'Käännä kaikki puuttuvat',
      weekNumber: 'Viikon numero',
      printablePdf: 'Tulostettava menu:'
    }
  },
  en: {
    nav: {
      home: 'Home',
      lunch: 'Lunch',
      about: 'About',
      contact: 'Contact'
    },
    hero: {
      badge: 'Restaurant La Maria · Vantaa',
      title: 'Delicious Lunch Buffet',
      subtitle: 'A varied lunch buffet prepared daily from fresh ingredients in a warm atmosphere.',
      ctaLunch: 'See Lunch Menu',
      ctaContact: 'Contact Us'
    },
    info: {
      hoursTitle: 'Opening Hours',
      weekdays: 'Mon–Fri',
      weekend: 'Sat–Sun',
      closed: 'Closed',
      locationTitle: 'Location',
      phoneTitle: 'Call Us'
    },
    lunch: {
      heading: "Week's Lunch",
      subheading: 'Daily changing lunch buffet prepared from fresh ingredients.',
      days: {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday'
      },
      week: 'Week',
      servedDaily: 'Served Mon–Fri 10am–4pm',
      downloadPdf: "Download week's menu (PDF)",
      noMenu: "Today's menu will be updated soon."
    },
    about: {
      heading: 'About Us',
      p1: 'With over 15 years of experience in the restaurant industry, Restaurant La Maria is a trusted choice for a high-quality lunch buffet. Professionalism, consistent quality, and excellent service form the foundation of our operation.',
      p2: 'We prepare a diverse and balanced buffet daily from fresh, high-quality ingredients, so we can always offer our customers a delicious and reliable lunch experience. Whether you are on a quick lunch break or enjoying a relaxed meal, our efficient service and cozy atmosphere guarantee a pleasant moment.',
      p3: 'At Restaurant La Maria, experience is not just a number — it shows in every dish we serve.',
      catering: 'Our premises accommodate up to 200 people, and we also offer full catering service for parties and events.',
      stat1: 'Years of experience',
      stat2: 'Fresh ingredients',
      stat3: 'Seat capacity'
    },
    contact: {
      heading: 'Contact',
      subheading: 'Welcome to Restaurant La Maria!',
      address: 'Address',
      phone: 'Phone',
      email: 'Email',
      hours: 'Opening Hours',
      directions: 'Get Directions'
    },
    footer: {
      tagline: 'Versatile lunch buffet in Vantaa',
      rights: 'All rights reserved.'
    },
    admin: {
      title: 'Admin Panel',
      login: 'Log in',
      password: 'Password',
      logout: 'Log out',
      wrongPassword: 'Wrong password',
      manageLunch: 'Manage Lunch Menu',
      dishName: 'Dish name (Finnish)',
      dishDesc: 'Description (Finnish)',
      dishNameEn: 'Dish name (English)',
      dishDescEn: 'Description (English)',
      translate: 'Translate to English',
      translating: 'Translating...',
      save: 'Save',
      saving: 'Saving...',
      saved: 'Saved!',
      add: 'Add dish',
      remove: 'Remove',
      day: 'Day',
      scheduleTitle: 'Schedule update',
      scheduleHint: 'Set how long until the changes become visible on the website. Leave at zero to update immediately.',
      hours: 'Hours',
      minutes: 'Minutes',
      saveInstant: 'Save now',
      scheduleBtn: 'Schedule & start timer',
      scheduled: 'Scheduled!',
      pendingNotice: 'Update pending activation',
      activatesIn: 'Activates in',
      cancelSchedule: 'Cancel schedule',
      translateAll: 'Translate all missing',
      weekNumber: 'Week number',
      printablePdf: 'Printable menu:'
    }
  }
};
